export const GetDarkModeStyles = (darkMode: boolean) => {
    return {
        textColour: darkMode ? "white" : "black",
        backgroundColor: darkMode ? "black" : "white",
        className: darkMode ? "darkModeLabelDisabled" : "",
        panelClassName: darkMode ? "darkMode" : "lightMode",
    };
};

export interface DarkModeStyles {
    textColour: string;
    backgroundColor: string;
    className: string;
    panelClassName: string;
}
